export default "__VITE_ASSET__26G8o2pJ__";